const EventPageModel = {
  id: "",
  usersId: "",
  eventName: "",
  eventDecription: "",
  eventStatusName: "",
  eventCategoryTypeName: "",
  countryName: "",
  stateName: "",
  currencyName: "",
  coverPicWide: "",
  coverPicSquare: "",
  parkinginstructions: "",
  healthSafetyInfo: "",
  startDate: "",
  startTime: "",
  endDate: "",
  endTime: "",
  street1: "",
  street2: "",
  city: "",
  timeZone: "",
  organizerName: "",
  organizerLogo: "",
  cateringApplications: [],
  retailApplications: [],
  tickets: [],
  documents: [],
  maps: [],
  sales: [],
};

export default EventPageModel;
